<template>
  <div class="commissionDatum">
    <!-- 标题：启用代理佣金设定 -->
    <div class="title">
      <!-- 复选框按钮and启用-->
      <label>
        <span class="enable-text">{{multiLanguage.templateName}} :</span>&nbsp;
        <el-select v-model="temp_name" size="small" @change="onTemplateChange" v-if="!newTempFlag">
          <el-option
            v-for="item in ibTemplate"
            :key="item.templateId"
            :label="`${item.templateId} ${multiLanguage[item.langKey]?'('+multiLanguage[item.langKey]+')':''}`"
            :value="item.templateId" v-if="item.isDisplay" >
          </el-option>
        </el-select>
        <input type="text" class='template_name' v-model="newTempName" v-if="newTempFlag"
                v-validate="{required:true,max:18,regex:/^([a-z]|[0-9]|[A-Z]|_)+$/}"
                name="newTempName"
                :style="errors.has('newTempName') ? 'border-color:#f44336;' : ''"
                @focus="onfocus=true" @blur="onfocus=false">
      </label>
      <!-- 按钮组 -->
      <div class="btn-box pull-right">
        <!-- 保存修改 -->
        <button class="btn" v-if="version == '1'" @click="submit">
          <span class="glyphicon glyphicon-edit"></span>
          {{multiLanguage.btnGroup.submit}}
        </button>
        <!-- 新建模板 -->
        <button class="btn" v-if="version == '1'" @click="createTemplate">
          <span class="glyphicon glyphicon-repeat"></span>
          {{newTempFlag?multiLanguage.btnGroup.back:multiLanguage.templateCreate}}
        </button>
      </div>
      <div v-if="newTempFlag">
        <span class="enable-text">{{multiLanguage.templateBase}} :</span>&nbsp;
        <el-select v-model="temp_name" size="small" style="width:250px;" @change="onTemplateChange">
          <el-option
            v-for="item in ibTemplate"
            :key="item.templateId"
            :label="`${item.templateId} ${multiLanguage[item.langKey]?'('+multiLanguage[item.langKey]+')':''}`"
            :value="item.templateId" v-if="item.isDisplay" >
          </el-option>
        </el-select>
      </div>
      <div v-if="!newTempFlag" :style="{'visibility':version==1?'hidden':'visible','height':viewBtn=='double'?'30px':'0px'}">
        <span class="enable-text">{{multiLanguage.templateHistory}} : </span>
        <el-select v-model="currentVersion"
          size="small" @change="onVersionChange" style="width:300px">
          <el-option
            v-for="item in tempHistory"
            :key="item.VERSION"
            :label="item.VERSION==0?`current`:`${item.UPDATE_BY} (${dataFormat(new Date(item.LAST_UPDATE))}) (${item.VERSION})`"
            :value="item.VERSION">
          </el-option>
        </el-select>
        <div class="clear"></div>
      </div>&nbsp;
      <div class="clear"></div>
    </div>
    <div>&nbsp;
      <!-- 子组件：内返佣金设定 -->
      <internal-commission v-if="mode == 0 || mode == 2" 
        :commission="commission" 
        :groupSeq="groupSeq" 
        :multiLanguage="multiLanguage"
        :version="version"
        :viewBtn="viewBtn"
        ref="internalCommission">
      </internal-commission>
    </div>&nbsp;
    <!-- 标题：启用多层佣金分配 -->
    <div class="title">
      <span class="table-title">{{multiLanguage.upperCommissiondistribution}}</span>
    </div>
    <div>
      <!-- 子组件：规则设定 -->
      <rule-setting
        :enableUpperCalc="commission.enableUpperCalc"
        :multiLanguage="multiLanguage"
        :groupSeq="groupSeq" 
        :version="version"
        :relation="relation"
        :currentIB="currentIB"
        :rule="rule"
        :ruleSeq="ruleSeq"
        :viewBtn="viewBtn"
        ref="ruleSetting"
        @checkId="checkIdFn">
      </rule-setting>
    </div>
    <!-- 第三方组件：模态框，弹出成功 or 失败的提示信息 -->
    <Modal v-model="showModal" size="sm" :header="false" :footer="false">
      <div v-show="!sucSave">
          <i class="glyphicon glyphicon-warning-sign color-red"></i>
          <span class="color-red">{{multiLanguage.submitResult.err}}</span>
      </div>
      <div v-show="sucSave">
          <i class="glyphicon glyphicon-ok color-green"></i>
          <span class="color-green">{{multiLanguage.submitResult.succeed}}</span>
      </div>
    </Modal>
  </div>
</template>

<script>
  var moment = require('moment');
  import internalCommission from './internalCommission'
  import ruleSetting from './ruleSetting'
  import { URL_TEMPLATE_SAVE,URL_DEFAULT,URL_TOOLCHECKID, URL_TEMPLATE_GET,URL_TEMPLATE_HISTORY } from 'api/commissionApi'
  import { getTimeDiff,updateTimeByUtc } from 'common/js/util'
  import { Modal,Btn,Dropdown } from 'uiv'
  import { Api } from 'api/commissionEnv'
  var api = new Api()
  export default {
    props: {
      curArea: {
        type: String,
        default: ''
      },
      multiLanguage: { //多语言
        type: Object,
        default: {}
      },
      version: { // 版本
        type: String,
        default: ''
      },
      viewBtn: { // 视图
        type: String,
        default: ''
      }
    },
    components:{
      Modal,
      Btn,
      Dropdown,
      internalCommission,
      ruleSetting
    },
    data () {
      return {
        showModal: false,
        sucSave: false,
        newTempFlag: false,
        newTempName: '',
        mode: 0,
        timeIsChange: '',
        enableDistribution: api.enableDistribution,
        commission: {
          cpa: [],
          enable: true,
          lvl: [],
          ReminderDate: '',
          ReminderMsg: '',
          sendEml: '',
          enableUpperCalc: '',
          updateBy: '',
          lastUpdate: '',
          confirmBy: '',
          lastConfirm: '',
          isConfirm: false,
        },
        groupSeq: [],
        relation: [],
        rule: [],
        ruleSeq: [],
        currentIB:{},
        ibTemplate: [],
        salesTemplate: [],
        cpaTemplate: null,
        tempHistory: [],
        currentVersion:null,
        temp_name: this.$parent.currentTemplate,
      }
    },
    mounted () {
      this.pageInit()
    },
    computed: {
      lvlLawful1 () { // 检查lvl的开始和结束是否合法
        let res = true
        if (this.mode == '0' || this.mode == '2') {
          this.commission.lvl.forEach((item,index) => {
            if(index < this.commission.lvl.length-1) {
              res = item.start - item.end > 0 ? false : true
            }
          })
        }
        return res
      },
      lvlLawful2 () { // 检查lvl的区间是否连贯
        let res = true
        if (this.mode == '0' || this.mode == '2') {
          this.commission.lvl.forEach((item,index) => {
            if(this.commission.lvl[index+1]) {
              if (!((this.commission.lvl[index+1].start - this.commission.lvl[index].end).toFixed(2) == 0.01)) {
                res = false
                return
              }
            }
          })
        }
        return res
      },
      cpaLawful1 () { // 检查cpa的开始和结束是否合法
        let res = true
        if (this.mode == '1' || this.mode == '2') {
          this.commission.cpa.forEach((item,index) => {
            if(index < this.commission.cpa.length-1) {
              res = item.start - item.end > 0 ? false : true
            }
          })
        }
        return res
      },
      cpaLawful2 () { // 检查cpa的区间是否连贯
        let res = true
        if (this.mode == '1' || this.mode == '2') {
          this.commission.cpa.forEach((item,index) => {
            if(this.commission.cpa[index+1]) {
              if (!((this.commission.cpa[index+1].start - this.commission.cpa[index].end).toFixed(2) == 1)) {
                res = false
                return
              }
            }
          })
        }
        return res
      },
      updateData () { // 需要更新的数据
        this.commission.lvl.forEach((item,index) => {
          item.lvl = index+1
          if(index == this.commission.lvl.length-1) item.end = '-1.00'
          if(index == 0) item.start = '0.00'
        })
        if (this.commission.cpa !== 'not exist') {
          this.commission.cpa.forEach((item,index) => {
            if(index == this.commission.cpa.length-1) item.end = '-1.00'
            if(index == 0) item.start = '1.00'
          })
        }
        let temp_lang = 'auto'
        if(this.ibTemplate && this.ibTemplate.length>0){
          this.ibTemplate.forEach(it=>{
            if(it.templateId==this.temp_name) temp_lang = it.langKey;
          })
        }
        return {
          newTempFlag: this.newTempFlag,
          updateBy: JSON.parse(sessionStorage.user).user_name,
          lvl: this.commission.lvl,
          rule: this.rule,
          tmplateName: this.newTempFlag?this.newTempName:this.temp_name,
          tmpLang: this.newTempFlag?'auto':temp_lang,
        }
      },
    },
    methods: {
      pageInit () {// 初始化数据
        this.$http.get(api.getUrl20(this.curArea,URL_TEMPLATE_GET+'/'+this.temp_name)).then(res => {
          if (res.data.code == 200 && res.data.data && res.data.msg == 'OK'){
            this.mode = 0
            this.commission.enableUpperCalc = true
            this.commission.lvl = res.data.data.setting
            this.rule = res.data.data.rulemapping
            this.groupSeq = res.data.data.groupSeq
            this.ruleSeq = res.data.data.ruleSeq
            this.ibTemplate = res.data.data.ibTemplate
            this.salesTemplate = res.data.data.salesTemplate
            this.tempHistory = [{TEMPLATE_ID:this.temp_name,VERSION:0}].concat(res.data.data.history)
            this.currentVersion = this.tempHistory.length>0?this.tempHistory[0].VERSION:null
            if(!this.ibTemplate || this.ibTemplate.length == 0) this.temp_name = ''
          }
        })
      },
      submit () {// 提交
        if(this.newTempFlag){
          let sameName = false
          this.ibTemplate.forEach(it=>{
              if(it.templateId==this.newTempName) sameName = true
          })
          this.salesTemplate.forEach(it=>{
            if(it.templateId==this.newTempName) sameName = true
          })
          if(sameName){
            alert(this.multiLanguage.alertMsg.templateExist)
            return
          }
        }
        function isTrueFn(element) {
          return (element == true)
        }
        let arr = [this.$validator.validateAll()]
        arr.push(this.$refs.internalCommission.$validator.validateAll())
        arr.push(this.$refs.ruleSetting.$validator.validateAll())
        Promise.all(arr).then(result => {
          if(this.lvlLawful1 
            && this.lvlLawful2 
            && this.cpaLawful1 
            && this.cpaLawful2 
            && result.every(isTrueFn) 
            && this.checkRuleSetting1(this.updateData.rule)) {
            // 发请求去保存
            // console.log('发请求')
            this.$http.post(api.getUrl20(this.curArea,URL_TEMPLATE_SAVE+'/0'),this.updateData).then(res => {
              if (res.data.code == 200)  {
                this.showModal = true
                this.sucSave = true
                this.ibTemplate = res.data.data.ibTemplate
                this.tempHistory = res.data.data.history
                this.temp_name = this.updateData.tmplateName
                if(this.tempHistory.length>0) this.currentVersion = this.tempHistory[0].VERSION
              }
              else {
                this.showModal = true
                this.sucSave = false
              }
            })
          } else {
            this.showModal = true
            this.sucSave = false
          }
        })
      },
      onTemplateChange(tempId){
        this.pageInit()
        this.$parent.currentTemplate = this.temp_name
      },
      onVersionChange(version){
        if(version == 0){
          this.pageInit()
          return;
        }
        this.$http.get(api.getUrl20(this.curArea,URL_TEMPLATE_HISTORY)+'/'+this.temp_name+'/'+this.currentVersion).then((res) => {
          if (res.data.code === 200) {
              this.commission.lvl = res.data.data.setting
              this.rule = res.data.data.rulemapping
          }
        })
      },
      createTemplate(){
        this.newTempName = ''
        this.newTempFlag = !this.newTempFlag
      },
      checkIdFn (ruleItem) { // 检查id是否在关系图
        this.$http(api.getUrl20(this.curArea,URL_TOOLCHECKID),{params:{id: ruleItem.commTarget,type: 'IB'}}).then(res => {
          let result = res.data.data.result
          if (!result) {
            alert(this.multiLanguage.alertMsg.noAccount)
            ruleItem.commTarget = ''
          }
        })
      },
      checkRuleSetting1(rule) {
        let checkRule = {}
        for (let val of rule) {
            let rCheck = {}
            for (let r of val) {
                if (r.ruleId == 3 || r.ruleId == 5) {
                    if (!checkRule[`${r.ruleId}-${r.ruleGroup}`]) {
                        checkRule[`${r.ruleId}-${r.ruleGroup}`] = { count: 1, content: JSON.stringify({ spreadEnable: r.spreadEnable, externalCommissionEnable: r.externalCommissionEnable, internalCommissionEnable: r.internalCommissionEnable }) }
                    } else {
                        if (JSON.stringify({ spreadEnable: r.spreadEnable, externalCommissionEnable: r.externalCommissionEnable, internalCommissionEnable: r.internalCommissionEnable }) != checkRule[`${r.ruleId}-${r.ruleGroup}`].content) {
                          // 存在“分层最高金额”这个规则设定时，加点、外佣、内返的值必须相同
                          alert(this.multiLanguage.alertMsg.checkRuleFail1)
                          return false
                        }
                        else {
                            checkRule[`${r.ruleId}-${r.ruleGroup}`].count++
                        }
                    }
                    if (rCheck[`${r.ruleId}-${r.ruleGroup}`] == undefined) rCheck[`${r.ruleId}-${r.ruleGroup}`] = true
                    else {
                      return false
                    }
                }
            }
        }
        for (let key in checkRule) {
            if (checkRule[key].count != rule.length) {
              // 存在“分层最高金额”这个规则时，每个级别都必须有一条相同的“分层最高金额”，并保证“加点、外佣、内返”一致
              alert(this.multiLanguage.alertMsg.checkRuleFail2)
              return false
            }
        }
        return true
      },
      dataFormat(date){
        return moment(date).format('YYYY-MM-DD HH:mm:ss')
      }
    },
    watch: {
      curArea () {
        this.$parent.currentTemplate = 'DEFAULT'
        this.temp_name = 'DEFAULT'
        this.pageInit()
      }
    }
  }
</script>

<style lang="scss" scoped>
  .commissionDatum{
    input[type='checkbox']{
      vertical-align: middle;
      margin-top: 0;
    }
    .title{
      position: relative;
      border-bottom: 2px solid #3F51B5;
      input[type='checkbox']{
        width: 22px;
        height: 22px;
      }
      span{
        color: #3F51B5;
        font-weight: 550;
        font-size: 15px;
      }
      .template_name{
        width: 250px;
        height: 30px;
        padding: 5px;
        border: 1px solid #ddd;
        border-radius: 3px;
      }
      .template_choose{
        width: 100px;
        height: 30px;
        line-height: 20px;
      }
      .enable-text{
        font-size: 16px;
        font-weight: 700;
        color: #F08712;
      }
      .table-title{
        font-size: 20px;
        margin-left: 20px;
      }
      .btn-box{
        height: 50px;
        button{
          margin-left: 10px;
          background-color: #3f51b5;
          color:#fff;
        }
        span{
          color: #fff;
        }
      }
    }
    .last-update-box{
      margin-top: 5px;
      text-align: right;
      color: #3f51b5;
      font-weight: 550;
      font-size: 16px;
    }
    .cpa-switch-box{
      margin: 5px 0 10px;
      .cpa-switch{
        .internal{
          border-radius: 3px 0 0 3px;
        }
        .CPA{
          border-radius: 0;
          margin-left: -4px;
        }
        .internalAndCPA{
          border-radius: 0 3px 3px 0;
          margin-left: -5px
        }
        .active{
          background-color: #3F51B5!important;
          color: #fff!important;
        }
        .default-color{
          color: #333;
        }
      }
    }
    .expired-box{
        margin: 10px 0;
        .ReminderDate,.ReminderMsg{
            width: 49%;
        }
        .send-eml{
            margin-left: 20px;
            margin-top: 16px;
        }
    }
    .disabled{
      background: #e9e9e9;
      border-color: #e9e9e9;
      color: #333;
    }
  }
</style>



// WEBPACK FOOTER //
// ibTemplateSettingContent.vue?33aab927